import React, { useState, useEffect } from "react";
import SearchableDropdown from "./SearchableDropdown";
import "./LocationDropdowns.css";
import { DepartamentoService } from "../services/DepartamentoService";
import { ProvinciaService } from "../services/ProvinciaService";
import { DistritoService } from "../services/DistritoService";
import { RegionService } from "../services/RegionService";

const LocationDropdowns = ({
  selectedDepartment,
  selectedProvince,
  selectedDistrict,
  selectedZone,
  onDepartmentChange,
  onProvinceChange,
  onDistrictChange,
  onZoneChange,
  showZones = true,
  className = "",
  token,
  errors,
}) => {
  const [departments, setDepartments] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState({
    departments: false,
    provinces: false,
    districts: false,
    zones: false,
  });

  // Cargar departamentos al montar el componente
  useEffect(() => {
    loadDepartments();
    loadZones();
  }, []);

  // Cargar provincias cuando cambie el departamento
  useEffect(() => {
    if (selectedDepartment) {
      loadProvinces(selectedDepartment);
    } else {
      setProvinces([]);
      setDistricts([]);
    }
  }, [selectedDepartment]);

  // Cargar distritos cuando cambie la provincia
  useEffect(() => {
    if (selectedProvince) {
      loadDistricts(selectedProvince);
    } else {
      setDistricts([]);
    }
  }, [selectedProvince]);

  const loadDepartments = async () => {
    setLoading((prev) => ({ ...prev, departments: true }));
    try {
      const data = await DepartamentoService.fetchDepartamentos(token);
      setDepartments(data);
    } catch (error) {
      console.error("Detalles del error:", error.response?.data || error.message);
    } finally {
      setLoading((prev) => ({ ...prev, departments: false }));
    }
  };

  const loadProvinces = async (departmentId) => {
    setLoading((prev) => ({ ...prev, provinces: true }));
    try {
      const data = await ProvinciaService.fetchProvinciasPorDepartamento(token, departmentId);
      setProvinces(data);
    } catch (error) {
      console.error("Error al cargar provincias:", error);
      console.error("Detalles del error:", error.response?.data || error.message);
    } finally {
      setLoading((prev) => ({ ...prev, provinces: false }));
    }
  };

  const loadDistricts = async (provinceId) => {
    setLoading((prev) => ({ ...prev, districts: true }));
    try {
      const data = await DistritoService.fetchDistritosPorProvincia(token, provinceId);
      setDistricts(data);
    } catch (error) {
      console.error("Error al cargar distritos:", error);
      console.error("Detalles del error:", error.response?.data || error.message);
    } finally {
      setLoading((prev) => ({ ...prev, districts: false }));
    }
  };

  const loadZones = async () => {
    setLoading((prev) => ({ ...prev, zones: true }));
    try {
      const data = await RegionService.fetchRegiones(token);
      setZones(data);
    } catch (error) {
      console.error("Error al cargar zonas:", error);
      console.error(
        "Detalles del error:",
        error.response?.data || error.message
      );
    } finally {
      setLoading((prev) => ({ ...prev, zones: false }));
    }
  };

  const handleDepartmentChange = (value) => {
    onDepartmentChange(value);
    // Limpiar selecciones dependientes
    onProvinceChange("");
    onDistrictChange("");
    onZoneChange("");
  };

  const handleProvinceChange = (value) => {
    onProvinceChange(value);
    // Limpiar selecciones dependientes
    onDistrictChange("");
    onZoneChange("");
  };

  const handleDistrictChange = (value) => {
    onDistrictChange(value);
    // Limpiar selección de zona
    onZoneChange("");
  };

  const handleZoneChange = (value) => {
    onZoneChange(value);
  };

  return (
    <div >
      <div className="form-grid">
        {/* Departamento */}
        <div className="form-group">
          <label htmlFor="department">Departamento *</label>
          <SearchableDropdown
            options={departments}
            value={selectedDepartment}
            onChange={handleDepartmentChange}
            placeholder="Seleccionar departamento"
            disabled={loading.departments}
            loading={loading.departments}
          />
          {errors?.department && (
            <span className="error">{errors.department}</span>
          )}
        </div>

        {/* Provincia */}
        <div className="form-group">
          <label htmlFor="province">Provincia *</label>
          <SearchableDropdown
            options={provinces}
            value={selectedProvince}
            onChange={handleProvinceChange}
            placeholder="Seleccionar provincia"
            disabled={!selectedDepartment || loading.provinces}
            loading={loading.provinces}
          />
          {errors?.provinces && (
            <span className="error">{errors.provinces}</span>
          )}
        </div>
      </div>
      <div className="form-grid">
        {/* Distrito */}
        <div className="form-group">
          <label htmlFor="district">Distrito *</label>
          <SearchableDropdown
            options={districts}
            value={selectedDistrict}
            onChange={handleDistrictChange}
            placeholder="Seleccionar distrito"
            disabled={!selectedProvince || loading.districts}
            loading={loading.districts}
          />
          {errors?.districts && (
            <span className="error">{errors.districts}</span>
          )}
        </div>

        {/* Zona (opcional) */}
        {showZones && (
          <div className="form-group">
            <label htmlFor="zone">Regiones</label>
            <SearchableDropdown
              options={zones}
              value={selectedZone}
              onChange={handleZoneChange}
              placeholder="Seleccionar región"
              disabled={loading.zones}
              loading={loading.zones}
            />
            {errors?.zones && <span className="error">{errors.zones}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationDropdowns;
